import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";
import visuallyHiddenSx from "../../utils/a11y/visuallyHiddenSx";
import { registerLiveRegion } from "../../utils/a11y/announcer";

// Mount inside every Dialog so announce() reaches screen readers while the page behind is aria-hidden.
const LiveRegion = () => {
  const [messages, setMessages] = useState({ polite: "", assertive: "" });
  const repeatRef = useRef(false);

  useEffect(
    () =>
      registerLiveRegion((message, politeness) => {
        // alternating a trailing nbsp makes a repeated message count as a change
        repeatRef.current = !repeatRef.current;
        setMessages((current) => ({
          ...current,
          [politeness]: repeatRef.current ? message : `${message}\u00A0`,
        }));
      }),
    []
  );

  return (
    <>
      <Box
        component="div"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        sx={visuallyHiddenSx}
      >
        {messages.polite}
      </Box>
      <Box
        component="div"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        sx={visuallyHiddenSx}
      >
        {messages.assertive}
      </Box>
    </>
  );
};

export default LiveRegion;
